import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class LeaveType extends DomainObject {
  name;

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable
    });

    this.merge(other);
  }
}

export default LeaveType;
